import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

export default function SignIn({ onLogin }) {
  const { instance } = useMsal();
  const [error, setError] = useState(null);

  const handleLogin = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest);
      const { idToken } = loginResponse;
      console.log("ID Token:", idToken);
      const decodedToken = jwtDecode(idToken);
      console.log("Decoded ID Token:", decodedToken);
      const tenantId = decodedToken.tid; // Extract tenant ID
      localStorage.setItem("tenantId", tenantId); // Store tenant ID

      const response = await axios.post(
        "https://erp-production-72da01c8e651.herokuapp.com/api/auth/login",
        { idToken, tenantId },
        { withCredentials: true },
      );

      if (response.status === 200) {
        const { user, token } = response.data;
        localStorage.setItem("token", token);
        localStorage.setItem("tenantId", tenantId);
        onLogin(user);
      }
    } catch (e) {
      console.error("Login error:", e);
      setError(
        e.response?.data?.message ||
          "Failed to login. Please check your tenant or try again.",
      );
    }
  };

  return (
    <div
      className="relative min-h-screen bg-cover bg-center"
      style={{
        backgroundImage:
          "url(https://torontotapers.ca/static/8b21ca291a4ef21554f080ba5f9431f2/3efec/the_quay_tower_iii_toronto_on_nov_2023_44e1123363.webp)",
      }}
    >
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative flex items-center justify-center min-h-screen">
        <div className="bg-white rounded-lg p-8 shadow-lg text-center">
          <h1 className="text-2xl font-bold mb-4">Toronto Tapers</h1>
          <div className="flex justify-center">
            <button
              onClick={handleLogin}
              className="flex items-center justify-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2"
            >
              <img
                src="/Microsoft_logo.png"
                alt="Microsoft Logo"
                className="h-5 w-5"
              />
              Sign in to Microsoft
            </button>
          </div>
          {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
          <p className="mt-4 text-sm text-gray-600">
            Sign in to manage projects
          </p>
        </div>
      </div>
    </div>
  );
}
